import { AddEmailAddress } from 'components';
import { TripContext } from 'contexts';
import React, { Fragment, useContext } from 'react';
import {  useParamService } from 'services';

import './edit-company-emails.scss';
import { VerifyCompanyEmailCard } from 'components/recap';

export const EditCompanyEmailsPage = () => {
    const tripContext = useContext(TripContext);
    const { getIntValue } = useParamService;
    const stopId: number | undefined = getIntValue('stopId')

    return (
        <Fragment>
            <VerifyCompanyEmailCard 
                isEditEmailPage={true}
                emailHeaderText={'Delete current e-mail address'}
                stopId = {stopId!}
                />
            <AddEmailAddress 
                stopId={stopId!}                
                />
        </Fragment>
    )
}
